// extracted by mini-css-extract-plugin
export default {"outlinedToday":"styles_outlinedToday__y2C9y"};